import './index.scss'
import 'bootstrap/dist/css/bootstrap.css'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import { configure } from 'mobx'
import { AsyncTrunk } from 'mobx-sync'
import AppRouter from './App'
import * as store from './store'
 
configure({ enforceActions: 'observed' })

const trunk = new AsyncTrunk(store.authStore, { delay: 100 })

trunk.init().then(() => {
    store.authStore.setToken()
    ReactDOM.render(
        <Provider {...store}>
            <AppRouter />
        </Provider>,
        document.getElementById('app') as HTMLElement
    )
})
